import React, { useContext, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import "./BannerHome.css";
import { GetUserContext } from '../Context/GetUserContext';
import newFraga from '../controller/api/New_Fraga'
//institucional
import banner01 from '../img/banners/corven_default.png';
import banner02 from '../img/banners/wolf_inside.png';
//institucional


const BannerHome = () => {
    const {
        setProducts,
        setPage,
        setLoad,
        setActivedPagination,
        setSelectedFabricante,
        selectedFabricante,
        size,
        nomePeca,
        selectedBrands,
        selectedNames,
        selectedModels,
        selectedAllYears,
        selectedEnginer,
        selectedEnginerConfig,
        idCompany,
        page
    } = useContext(GetUserContext)

    const NewFraga = new newFraga();

    const handleFrabicanteBanner = (fabricante) => {
        setSelectedFabricante(fabricante);
        setLoad(true);
        setPage(1);
        setActivedPagination(true);

        NewFraga.prodName(
            nomePeca,
            selectedBrands,
            selectedNames,
            selectedModels,
            selectedAllYears,
            selectedEnginer,
            selectedEnginerConfig,
            fabricante,
            idCompany,
            1
        )
            .then(response => {
                setProducts(response);
                setLoad(false);
            })
            .catch(err => {
                console.error("Erro ao buscar produtos:", err);
                setLoad(false);
            });
    }


    return (


        size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
            (<>
                <Carousel className='carrocel-home' data-bs-theme="white" >
                    <Carousel.Item
                        className='item-carrosel item-carrosel-custom'
                        onClick={() => { handleFrabicanteBanner('CORVEN') }}
                    >
                        <img
                            src={banner01}
                            alt="Second slide"
                        />

                    </Carousel.Item>

                    <Carousel.Item
                        onClick={() => { handleFrabicanteBanner('WOLF') }}
                        className='item-carrosel item-carrosel-custom'>
                        <img
                            src={banner02}
                            alt="Third slide"
                        />
                    </Carousel.Item>
                </Carousel>
            </>)
            :
            (
                <>
                    <Carousel className='carrocel-home' data-bs-theme="white" >
                        <Carousel.Item
                            onClick={() => { handleFrabicanteBanner('CORVEN') }}
                            className='item-carrosel item-carrosel-custom' >
                            <img

                                src={banner01}
                                alt="Second slide"
                            />

                        </Carousel.Item>

                        <Carousel.Item
                            onClick={() => { handleFrabicanteBanner('WOLF') }}
                            className='item-carrosel item-carrosel-custom'>
                            <img
                                src={banner02}
                                alt="Third slide"
                            />
                        </Carousel.Item>


                    </Carousel >

                </>
            )

    )
}

export default BannerHome